/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import { Dropdown, Menu, Modal } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import DokanIcons from '../icon/DokanIcons';
import DokanConfirmModal from '../modal/DokanConfirmModal';
import { deleteProduct, getSingleProduct } from '../../redux/products/productsActions';

function DokanTableEditDropdown({ record }) {
    const [visible, setVisible] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const editProduct = async (product) => {
        await dispatch(getSingleProduct(product));
        history.push(`/products/update/${product.id}`);
    };
    const quickEditProduct = (product) => {
        console.log('quickEditProduct ', product);
    };
    const viewProduct = (product) => {
        console.log('veiwProduct ', product);
    };

    const duplicateProduct = (product) => {
        console.log('duplicateProduct ', product);
    };
    const trashProduct = (product) => {
        // [product.id];
        Modal.confirm({
            title: 'Do you want to delete these items?',
            content: '',
            onOk() {
                dispatch(deleteProduct([product.id]));
            },
            onCancel() {},
        });
    };

    const menu = (
        <Menu>
            <Menu.Item onClick={() => editProduct(record)}>Edit</Menu.Item>
            <Menu.Item onClick={() => quickEditProduct(record)}>Quick Edit</Menu.Item>
            <Menu.Item className="flex" onClick={() => trashProduct(record)}>
                Trash
            </Menu.Item>
            {/* <Menu.Item className="flex" onClick={() => viewProduct(record)}>
                View
            </Menu.Item> */}
            <Menu.Item onClick={() => duplicateProduct(record)}>Duplicate</Menu.Item>
        </Menu>
    );

    return (
        <>
            <Dropdown overlay={menu} trigger={['click']}>
                <button
                    type="button"
                    className="ant-dropdown-link focus:outline-none"
                    onClick={(e) => e.preventDefault()}
                >
                    <DokanIcons icon="#more" />
                </button>
            </Dropdown>
        </>
    );
}

export default DokanTableEditDropdown;
